import { render, staticRenderFns } from "./NumberParameterType.vue?vue&type=template&id=b6bc3254"
import script from "./NumberParameterType.vue?vue&type=script&lang=js"
export * from "./NumberParameterType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports